<template>
  <div id="content-wrap" class="content-wrapper">
    <section class="content">
      <div class="col-md-6 col-sm-6 col-xs-12">
        <OrderGeneral :orderId="orderId">
        </OrderGeneral>
      </div>
      <div class="col-md-6 col-sm-6 col-xs-12">
        <ChatBox></ChatBox>
      </div>
      <div class="col-md-6 col-sm-6 col-xs-12">
        <DataHistory :orderId="orderId"></DataHistory>
      </div>
      <div class="col-md-6 col-sm-6 col-xs-12">
        <OrderCallHistory :orderId="orderId"></OrderCallHistory>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12">
        <OrderDetailList :orderId="orderId" type="NEW_BUY"></OrderDetailList>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12">
        <OrderDetailList :orderId="orderId" type="ANNUAL_BUY"></OrderDetailList>
      </div>
    </section>
  </div>
</template>

<script>
import Box from '../../components/Box'
import DataHistory from './DataHistory'
import OrderCallHistory from './OrderCallHistory'
import OrderGeneral from './OrderGeneral'
import ChatBox from './ChatBox'
import OrderDetailList from './OrderDetailList'

export default {
  name: 'OrderDetail',
  components: {
    OrderDetailList,
    Box,
    OrderGeneral,
    OrderCallHistory,
    DataHistory,
    ChatBox
  },
  data () {
    return {
      orderId: parseInt(this.$route.params.id),
      loading: false,
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/order_management/OrderDetail.vue